import { ErrorService } from '../../core/services/error.service';
import { AccountService } from '../../core/services/api/account.service';
import { Component, OnInit } from '@angular/core';
import { SavedOffersFilterService } from './saved-offers-filter.service';
import { SavedOffersFilter } from './saved-offers-filter';
import { finalize } from 'rxjs/operators';
import { Campaign } from '../../core/models/campaign/campaign';
import { environment } from '../../../environments/environment';

@Component({
    selector: 'app-saved-offers',
    templateUrl: './saved-offers.component.html',
    styleUrls: ['./saved-offers.component.scss'],
    standalone: false
})
export class SavedOffersComponent implements OnInit {
  public environment = environment;

  campaigns: Campaign[];
  isLoading: boolean = false;
  total: number = 0;
  params = this.savedOffersFilterService.filter
    ? this.savedOffersFilterService.filter
    : new SavedOffersFilter();

  constructor(
    private accountService: AccountService,
    private errorService: ErrorService,
    private savedOffersFilterService: SavedOffersFilterService,
  ) {}

  ngOnInit() {
    this.getSavedCampaigns(this.params);
  }

  getSavedCampaigns(params: SavedOffersFilter, reload?: boolean) {
    if (reload) this.params.currentPage = 1;

    this.isLoading = true;
    this.params = params;
    this.savedOffersFilterService.filter = params;
    this.campaigns = [];

    this.accountService
      .getSavedCampaigns(this.params)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe(
        (data) => {
          this.campaigns = data.data;
          this.total = data.total;
        },
        (err) => {
          this.errorService.showError(err);
        },
      );
  }
}
